/**
 * Copyright 2022-2025, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __awaiter } from "tslib";
import { getDefaultAsyncStorage } from "../import.react_native/@react-native-async-storage/async-storage";
export class AsyncStorageCache {
    constructor() {
        this.operation = 'async';
        this.asyncStorage = getDefaultAsyncStorage();
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = yield this.asyncStorage.getItem(key);
            return value ? JSON.parse(value) : undefined;
        });
    }
    remove(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.asyncStorage.removeItem(key);
        });
    }
    set(key, val) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.asyncStorage.setItem(key, JSON.stringify(val));
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.asyncStorage.clear();
        });
    }
    getKeys() {
        return __awaiter(this, void 0, void 0, function* () {
            return [...yield this.asyncStorage.getAllKeys()];
        });
    }
    getBatched(keys) {
        return __awaiter(this, void 0, void 0, function* () {
            const items = yield this.asyncStorage.multiGet(keys);
            return items.map(([key, value]) => value ? JSON.parse(value) : undefined);
        });
    }
}
export const __platforms = ['react_native'];
//# sourceMappingURL=async_storage_cache.react_native.js.map